import { Injectable } from '@angular/core';
import { DroplistItem, PageTabsLayoutPageService } from '@eforall/dashboard';


/**
 * The list of tabs on this page
 */
export enum AlumniPageTabId {
	Alumni = 1,
	Tab1 = 2,
	Tab2 = 3,
}

/**
 * The list if main tab droplist views on this page
 */
export enum AlumniPageViewId {
	Reports = 1,
	Services = 2,
}


@Injectable({ providedIn: 'root' })
export class AlumniService extends PageTabsLayoutPageService<AlumniPageTabId, AlumniPageViewId> {

	private static readonly _viewDroplistItems: DroplistItem<never, AlumniPageViewId>[] = [
		{
			uniqueId: AlumniPageViewId.Reports, iconContext: {
				iconClass: 'fa-grip-horizontal',
				iconStyle: 'fa-solid',
				text: 'Reports',
				hideText: 'never',
			}, customSort: '1'
		},
		{
			uniqueId: AlumniPageViewId.Services, iconContext: {
				iconClass: 'fa-grip-horizontal',
				iconStyle: 'fa-solid',
				text: 'Services',
				hideText: 'never',
			}, customSort: '2'
		},

	];


	constructor() {
		super(AlumniService._viewDroplistItems, AlumniService.name, AlumniPageTabId.Alumni, AlumniPageViewId.Reports);
	}

	public get viewId() {
		return AlumniPageViewId;
	}
}
